import { Component, EventEmitter, Input, OnChanges, OnInit, Output, } from '@angular/core';

import { AssociationStatusUtils } from '@shared/models';

@Component({
  selector: 'mojo-inactive-step',
  templateUrl: './inactive-step.component.html',
  styleUrls: ['./inactive-step.component.scss'],
})
export class InactiveStepComponent implements OnChanges, OnInit {
  @Input() index: number;
  @Input() step;
  @Input() completed: boolean;
  @Input() isCustomStep: boolean;
  @Input() showLabel = true;
  @Input() clickable: boolean;
  @Input() showTooltip: boolean;
  @Input() set loading(isLoading) {
    this.localLoading = isLoading;
    if (isLoading) {
      this.hovering = false;
    }
  }
  @Input() customColor: string;
  @Input() disableStepper: boolean;
  @Output() stepSelected = new EventEmitter<number>();

  hovering: boolean;
  localLoading = false;
  tplContext;
  stepLabel: string;

  ngOnInit() {
    this.stepLabel = this.step.label;
  }

  mouseOver() {
    if (!this.disableStepper) {
      this.hovering = true;
    }
  }

  mouseLeave() {
    if (!this.disableStepper) {
      this.hovering = false;
    }
  }

  onClick(index: number): void {
    if (this.clickable && !this.disableStepper) {
      this.stepSelected.emit(index);
    }
  }

  ngOnChanges() {
    this.tplContext = {
      $implicit: this.clickable,
    };
  }
}
